import { or } from "ramda"
import { isNotNil } from "ramda-extension"

// @ts-ignore
import actionListener from "@cirrus/legacy/app-author/alt/actionListener.es6"
// @ts-ignore
import applicationConfirmationActions from "@cirrus/legacy/app-author/alt/application/application/children/confirmation/actions/actions.es6"

export const errorStatus = 0
export const successStatus = 1

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(() => resolve({ timeout: true }), ms))

const pollingWorker = async (api: () => any, ms: number = 2000) => {
  const response = await api()
  
  if (isNotNil(response.data)) {
    const { status, isReady } = or(response.data.result, response.data)
    
    if (isReady) return response
    
    switch (status) {
      case errorStatus:
        return response
      
      case successStatus:
        return response
    }
  }
  
  await delay(ms)

  return null
}

export const polling = async (api: () => any, ms: number = 2000) => {
  while (true) {
    const result = await pollingWorker(api, ms)
    if (result) return result
  }
}

export const pollingLimited = async (api: () => any, ms: number = 2000, limit: number = 10) => {
  let attempts = 0
  while (attempts < limit) {
    const result = await pollingWorker(api, ms)
    if (result) return result
    attempts++
  }
}

export const confirmation = (params: any) =>
  new Promise((resolve) => {
    actionListener.addActionListenerOnce(applicationConfirmationActions.SUBMITTED, (result) =>
      resolve(result),
    )

    applicationConfirmationActions.show(params)
  })
